/**
 * Privacy banner: small X in the top right that is the same action as "Decline Optional".
 * The banner is injected by Shopify (#shopify-pc__banner), not by the theme, so this waits for it.
 * The X clicks Shopify's own #shopify-pc__banner__btn-decline, so consent is recorded as declined
 * exactly like the button (hiding the banner alone would record nothing).
 */
(function () {
  if (window.__pcPrivacyBannerX) return;
  window.__pcPrivacyBannerX = true;

  var css =
    '#shopify-pc__banner .pc-privacy-x{position:absolute;top:8px;right:8px;z-index:2;width:32px;height:32px;' +
    'padding:0;margin:0;display:flex;align-items:center;justify-content:center;background:#fff;color:#333132;' +
    'border:1px solid #333132;border-radius:4px;cursor:pointer;line-height:1}' +
    '#shopify-pc__banner .pc-privacy-x:hover{background:rgba(0,0,0,.08)}' +
    '#shopify-pc__banner .pc-privacy-x:focus-visible{outline:2px solid #333132;outline-offset:2px}' +
    '#shopify-pc__banner .pc-privacy-x svg{display:block;width:12px;height:12px}' +
    '#shopify-pc__banner .shopify-pc__banner__body{padding-right:28px}' +
    '@media (max-width:749px){#shopify-pc__banner .shopify-pc__banner__body p{font-size:16px}}';

  var style = document.createElement('style');
  style.setAttribute('data-pc-privacy-x', '');
  style.textContent = css;
  document.head.appendChild(style);

  function addX() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.querySelector('.pc-privacy-x')) return !!banner;
    var decline = document.getElementById('shopify-pc__banner__btn-decline');
    if (!decline) return false;
    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'pc-privacy-x';
    x.setAttribute('aria-label', 'Decline optional cookies and close');
    // Static icon markup, no user or remote content, so innerHTML is safe here.
    x.innerHTML =
      '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" fill="none"/></svg>';
    x.addEventListener('click', function () {
      var btn = document.getElementById('shopify-pc__banner__btn-decline');
      if (btn) btn.click();
    });
    banner.appendChild(x);
    return true;
  }

  // The banner shows a moment after load and can be re-rendered; poll briefly instead of observing the whole DOM.
  var tries = 0;
  var timer = setInterval(function () {
    addX();
    tries += 1;
    if (tries > 60) clearInterval(timer);
  }, 500);
})();
